// The left and right actions refer to the extra td element
// that we have at the beginning and end of each row
export const RIGHT_ACTIONS_MID_WIDTH = 9;
export const LEFT_ACTIONS_MID_WIDTH = 32;
